import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"
import { useState } from "react"

import Row from "../../../common/components/Row"

export default function AdminConciergeMagicLoginActions({
  loginLink,
  compact = false,
  openLabel = "Open as concierge",
  copyAriaLabel = "Copy concierge login link",
  copyLabel = "Copy login link",
}) {
  const [copied, setCopied] = useState(false)

  if (!loginLink) return null

  function handleCopy() {
    navigator.clipboard?.writeText(loginLink).then(() => {
      setCopied(true)
      window.setTimeout(() => setCopied(false), 1500)
    })
  }

  function handleOpen(event) {
    event.preventDefault()
    window.open(loginLink, "_blank", "noopener,noreferrer")
  }

  if (compact) {
    return (
      <Row
        gap={0.25}
        component="span"
        sx={{ width: "100%", justifyContent: "flex-end" }}
      >
        <Tooltip title={copied ? "Copied" : copyLabel}>
          <IconButton
            size="small"
            aria-label={copyAriaLabel}
            onClick={handleCopy}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title={openLabel}>
          <IconButton
            size="small"
            aria-label={openLabel}
            component="a"
            href={loginLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleOpen}
          >
            <OpenInNewIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Row>
    )
  }

  return (
    <Row gap={1} sx={{ justifyContent: "flex-end" }}>
      <Button
        size="small"
        variant="outlined"
        startIcon={<ContentCopyIcon />}
        onClick={handleCopy}
      >
        {copied ? "Copied" : copyLabel}
      </Button>
      <Button
        size="small"
        variant="contained"
        startIcon={<OpenInNewIcon />}
        href={loginLink}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleOpen}
      >
        {openLabel}
      </Button>
    </Row>
  )
}
